var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "slide-view",
    {
      directives: [
        {
          name: "empty",
          rawName: "v-empty",
          value: !_vm.canShowDetail,
          expression: "!canShowDetail",
        },
      ],
      ref: "sideView",
      staticClass: "d-view",
      attrs: {
        "no-listener-class": _vm.noListenerClass,
        "body-style": { padding: 0, height: "100%" },
        "xs-empty-icon": "nopermission",
        "xs-empty-text": "暂无权限",
      },
      on: { afterEnter: _vm.viewAfterEnter, close: _vm.hideView },
    },
    [
      _vm.loading !== null
        ? _c(
            "flexbox",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "main",
              attrs: { direction: "column", align: "stretch" },
            },
            [
              _vm.taskData
                ? _c(
                    "div",
                    { staticClass: "main__hd task-hd" },
                    [
                      _c(
                        "flexbox",
                        {
                          staticClass: "task-hd__top",
                          attrs: { justify: "space-between" },
                        },
                        [
                          _vm.taskData.create_user_info
                            ? _c(
                                "span",
                                { staticClass: "task-hd__top--create" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.taskData.create_user_info.realname
                                    ) +
                                      " 创建于 " +
                                      _vm._s(_vm.taskData.create_time)
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm.isArchive
                                ? _c(
                                    "span",
                                    { staticClass: "task-hd__top--info" },
                                    [
                                      _vm._v(
                                        "该任务已于 " +
                                          _vm._s(_vm.taskData.archive_time) +
                                          " 被归档"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isArchive
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "xr-btn--primary",
                                      attrs: {
                                        icon: "wk wk-activation",
                                        type: "primary",
                                      },
                                      on: { click: _vm.activateTask },
                                    },
                                    [_vm._v("激活")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isRecycle
                                ? _c(
                                    "span",
                                    { staticClass: "task-hd__top--info" },
                                    [
                                      _vm._v(
                                        "该任务已于 " +
                                          _vm._s(_vm.taskData.hidden_time) +
                                          " 被放入回收站"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isRecycle && _vm.getPermission("restoreTask")
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "xr-btn--primary",
                                      attrs: {
                                        icon: "wk wk-activation",
                                        type: "primary",
                                      },
                                      on: { click: _vm.recoverTask },
                                    },
                                    [_vm._v("恢复")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isRecycle && _vm.getPermission("cleanTask")
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "xr-btn--red",
                                      attrs: {
                                        icon: "el-icon-delete-solid",
                                        type: "primary",
                                      },
                                      on: { click: _vm.thoroughDeleteTask },
                                    },
                                    [_vm._v("彻底删除")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showArchiveBtn &&
                              _vm.getPermission("archiveTask")
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "xr-btn--green",
                                      attrs: {
                                        icon: "wk wk-archive",
                                        type: "primary",
                                      },
                                      on: { click: _vm.moreArchive },
                                    },
                                    [_vm._v("归档")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isRecycle && _vm.getPermission("deleteTask")
                                ? _c(
                                    "el-dropdown",
                                    {
                                      attrs: { trigger: "click" },
                                      on: { command: _vm.morkDropdownClick },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: { icon: "el-icon-more" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                icon: _vm._f("wkIconPre")(
                                                  "delete"
                                                ),
                                                command: "delete",
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "flexbox",
                        {
                          staticClass: "task-hd__middle",
                          attrs: { align: "stretch" },
                        },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              disabled: !_vm.getPermission("setTaskStatus"),
                            },
                            on: { change: _vm.completeMainTask },
                            model: {
                              value: _vm.taskData.checked,
                              callback: function ($$v) {
                                _vm.$set(_vm.taskData, "checked", $$v)
                              },
                              expression: "taskData.checked",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.nameVinput
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.taskData.name,
                                    effect: "dark",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "task-name",
                                        { "is-checked": _vm.taskData.checked },
                                      ],
                                      on: { click: _vm.editTaskName },
                                    },
                                    [_vm._v(_vm._s(_vm.taskData.name))]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "show-input" },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: 100, size: "medium" },
                                    model: {
                                      value: _vm.taskDataName,
                                      callback: function ($$v) {
                                        _vm.taskDataName = $$v
                                      },
                                      expression: "taskDataName",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "btn-box" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.submiteTaskName(
                                                _vm.taskDataName
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("保 存")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function ($event) {
                                              _vm.nameVinput = false
                                            },
                                          },
                                        },
                                        [_vm._v("取 消")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "flexbox",
                        { staticClass: "task-hd__bottom" },
                        [
                          _c(
                            "flexbox-item",
                            { staticClass: "priority" },
                            [
                              _c(
                                "flexbox",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.priorityVisible = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        disabled:
                                          !_vm.getPermission("setTaskPriority"),
                                        "popper-class": "no-padding-popover",
                                        placement: "bottom",
                                        trigger: "click",
                                      },
                                      model: {
                                        value: _vm.priorityVisible,
                                        callback: function ($$v) {
                                          _vm.priorityVisible = $$v
                                        },
                                        expression: "priorityVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "flexbox",
                                        { staticClass: "priority-select" },
                                        _vm._l(
                                          _vm.priorityList,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "priority-select-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.priorityBtn(
                                                      item,
                                                      _vm.taskData.priority
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "priority--icon",
                                                    style: {
                                                      backgroundColor:
                                                        item.color,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(item.label))]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "priority--icon",
                                          style: {
                                            backgroundColor: _vm.priority.color,
                                          },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [_vm._v(_vm._s(_vm.priority.label))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "head-btn__bd" }, [
                                    _c(
                                      "div",
                                      { staticClass: "head-btn__bd--des" },
                                      [_vm._v("优先级")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "flexbox-item",
                            [
                              _c(
                                "xh-user-cell",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.taskData.main_user
                                      ? [_vm.taskData.main_user]
                                      : [],
                                    "info-request": _vm.ownerListRequest,
                                    "info-params": _vm.ownerListParams,
                                    disabled:
                                      !_vm.getPermission("setTaskMainUser"),
                                    placement: "top",
                                    radio: "",
                                  },
                                  on: { "value-change": _vm.mainUserChange },
                                },
                                [
                                  _c(
                                    "flexbox",
                                    {
                                      staticClass: "head-btn",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      !_vm.taskData.main_user
                                        ? _c("i", {
                                            staticClass:
                                              "wk wk-l-plus head-btn__icon is-null",
                                          })
                                        : _c("xr-avatar", {
                                            staticClass: "user-img",
                                            attrs: {
                                              name: _vm.taskData.main_user
                                                ? _vm.taskData.main_user
                                                    .realname
                                                : "",
                                              size: 32,
                                              src: _vm.taskData.main_user
                                                ? _vm.taskData.main_user.img
                                                : "",
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "head-btn__bd" },
                                        [
                                          _vm.taskData.main_user
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "head-btn__bd--title",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.taskData.main_user
                                                        .realname
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "head-btn__bd--des",
                                            },
                                            [_vm._v("负责人")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.taskData.main_user &&
                                              _vm.getPermission(
                                                "setTaskMainUser"
                                              ),
                                            expression:
                                              "taskData.main_user && getPermission('setTaskMainUser')",
                                          },
                                        ],
                                        staticClass:
                                          "el-icon-close head-btn__close",
                                        on: {
                                          click: function ($event) {
                                            return _vm.submiteMainUser(null)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "flexbox-item",
                            [
                              _c(
                                "flexbox",
                                { staticClass: "head-btn" },
                                [
                                  _c("i", {
                                    staticClass: "wk wk-l-time head-btn__icon",
                                    class: [
                                      _vm.taskData.start_time
                                        ? "is-valve"
                                        : "is-null",
                                    ],
                                  }),
                                  _vm._v(" "),
                                  _c("el-date-picker", {
                                    attrs: {
                                      clearable: false,
                                      disabled:
                                        !_vm.getPermission("setTaskTime"),
                                      "picker-options": _vm.startTimeOptions,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.timeChange("start_time")
                                      },
                                    },
                                    model: {
                                      value: _vm.taskData.start_time,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.taskData,
                                          "start_time",
                                          $$v
                                        )
                                      },
                                      expression: "taskData.start_time",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "head-btn__bd" }, [
                                    _vm.taskData.start_time
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "head-btn__bd--title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.taskData.start_time,
                                                  "YYYY年MM月DD日"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "head-btn__bd--des" },
                                      [_vm._v("开始时间")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.taskData.start_time,
                                        expression: "taskData.start_time",
                                      },
                                    ],
                                    staticClass:
                                      "el-icon-close head-btn__close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTime("start_time")
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "flexbox-item",
                            [
                              _c(
                                "flexbox",
                                { staticClass: "head-btn" },
                                [
                                  _c("i", {
                                    staticClass: "wk wk-l-minus head-btn__icon",
                                    class: [
                                      _vm.taskData.stop_time
                                        ? "is-valve"
                                        : "is-null",
                                    ],
                                  }),
                                  _vm._v(" "),
                                  _c("el-date-picker", {
                                    attrs: {
                                      clearable: false,
                                      disabled:
                                        !_vm.getPermission("setTaskTime"),
                                      "picker-options": _vm.stopTimeOptions,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.timeChange("stop_time")
                                      },
                                    },
                                    model: {
                                      value: _vm.taskData.stop_time,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.taskData, "stop_time", $$v)
                                      },
                                      expression: "taskData.stop_time",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "head-btn__bd" }, [
                                    _vm.taskData.stop_time
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "head-btn__bd--title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.taskData.stop_time,
                                                  "YYYY年MM月DD日"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "head-btn__bd--des" },
                                      [_vm._v("结束时间")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.taskData.stop_time,
                                        expression: "taskData.stop_time",
                                      },
                                    ],
                                    staticClass:
                                      "el-icon-close head-btn__close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTime("stop_time")
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.taskData
                ? _c(
                    "flexbox",
                    { staticClass: "main__bd", attrs: { align: "stretch" } },
                    [
                      _c(
                        "div",
                        { staticClass: "main__bd--left" },
                        [
                          _c(
                            "flexbox",
                            [
                              _c(
                                "flexbox-item",
                                { staticClass: "participant" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "participant-title" },
                                    [_vm._v("参与人")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "flexbox",
                                    {
                                      staticClass: "participant-bd",
                                      attrs: { wrap: "wrap" },
                                    },
                                    [
                                      _vm._l(
                                        _vm.taskData.owner_list,
                                        function (item, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: index,
                                              staticClass: "owner-list",
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    placement: "bottom",
                                                    effect: "light",
                                                    "popper-class":
                                                      "tooltip-change-border",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content",
                                                      },
                                                      slot: "content",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.realname)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("xr-avatar", {
                                                    staticClass: "user-img",
                                                    attrs: {
                                                      name: item.realname,
                                                      size: 32,
                                                      src:
                                                        item.img ||
                                                        item.thumb_img,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.getPermission(
                                                "setTaskOwnerUser"
                                              )
                                                ? _c("img", {
                                                    staticClass:
                                                      "el-icon-close",
                                                    attrs: {
                                                      src: require("@/assets/img/delete_task.png"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteOwnerList(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.getPermission("setTaskOwnerUser")
                                        ? _c(
                                            "members-dep",
                                            {
                                              attrs: {
                                                "close-dep": true,
                                                "content-block": false,
                                                "user-checked-data":
                                                  _vm.taskData.owner_list,
                                                "user-request":
                                                  _vm.ownerListRequest,
                                                "user-params":
                                                  _vm.ownerListParams,
                                              },
                                              on: {
                                                popoverSubmit:
                                                  _vm.editOwnerList,
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "wk wk-l-plus participant-add",
                                                attrs: { slot: "membersDep" },
                                                slot: "membersDep",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.labelList
                                ? _c(
                                    "flexbox-item",
                                    { staticClass: "label" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "label-title" },
                                        [_vm._v("标签")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.labelList,
                                        function (item, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: index,
                                              staticClass: "item-color",
                                              style: {
                                                background: item.color
                                                  ? item.color
                                                  : "#ccc",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(item.name) +
                                                  "\n            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.getPermission("setTaskLabel")
                                        ? _c(
                                            "div",
                                            { staticClass: "add-tag" },
                                            [
                                              _c(
                                                "tag-index",
                                                {
                                                  attrs: {
                                                    placement: "right",
                                                    "task-data": _vm.taskData,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "add-btn",
                                                      attrs: {
                                                        slot: "editIndex",
                                                      },
                                                      slot: "editIndex",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "wk wk-l-plus",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [_vm._v("标签")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "secitons" }, [
                            _c("div", { staticClass: "section" }, [
                              _c("div", { staticClass: "section__hd" }, [
                                _c("i", { staticClass: "wk wk-write" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("描述")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "section__bd description" },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.addDescriptionShow,
                                          expression: "!addDescriptionShow",
                                        },
                                      ],
                                    },
                                    [
                                      _vm.taskData.description
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "description-content",
                                              on: {
                                                click: _vm.editTaskDescription,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.taskData.description)
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "description-empty",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "color-label" },
                                                [_vm._v("暂无描述")]
                                              ),
                                              _vm._v(" "),
                                              _vm.getPermission(
                                                "setTaskDescription"
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "add-btn",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.addDescriptionShow = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "wk wk-l-plus",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [_vm._v("描述")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.addDescriptionShow,
                                          expression: "addDescriptionShow",
                                        },
                                      ],
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          autosize: { minRows: 2 },
                                          maxlength: 2000,
                                          "show-word-limit": "",
                                          type: "textarea",
                                          placeholder: "请输入内容",
                                        },
                                        model: {
                                          value: _vm.addDescriptionTextarea,
                                          callback: function ($$v) {
                                            _vm.addDescriptionTextarea = $$v
                                          },
                                          expression: "addDescriptionTextarea",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "btn-box" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                              on: {
                                                click: _vm.submiteDescription,
                                              },
                                            },
                                            [_vm._v("保 存")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.addDescriptionTextarea =
                                                    ""
                                                  _vm.addDescriptionShow = false
                                                },
                                              },
                                            },
                                            [_vm._v("取 消")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "section" }, [
                              _c("div", { staticClass: "section__hd" }, [
                                _c("i", {
                                  staticClass: "wukong wukong-relevance",
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("相关信息")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "section__bd" },
                                [
                                  _c("related-business", {
                                    attrs: {
                                      "margin-left": "0",
                                      "all-data": _vm.allData,
                                      "show-foot":
                                        _vm.getPermission("saveTaskRelation"),
                                      "show-add":
                                        _vm.getPermission("saveTaskRelation"),
                                    },
                                    on: {
                                      checkRelatedDetail:
                                        _vm.checkRelatedDetail,
                                      checkInfos: _vm.checkInfos,
                                      unbind: _vm.unbindRelatedInfo,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "section" }, [
                              _c("div", { staticClass: "section__hd" }, [
                                _c("i", {
                                  staticClass: "wukong wukong-sub-task",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "子任务(" +
                                      _vm._s(_vm.subTaskComplete) +
                                      "/" +
                                      _vm._s(_vm.taskData.subTaskList.length) +
                                      ")"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "section__bd" }, [
                                _vm.taskData.pid == 0
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm.taskData.subTaskList.length != 0
                                              ? [
                                                  _c("el-progress", {
                                                    attrs: {
                                                      percentage:
                                                        _vm.subTaskProgress,
                                                      "stroke-width": 10,
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c("el-progress", {
                                                    attrs: { percentage: 0 },
                                                  }),
                                                ],
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.taskData.subTaskList.length != 0
                                          ? _vm._l(
                                              _vm.taskData.subTaskList,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    !item.showEdit
                                                      ? _c(
                                                          "flexbox",
                                                          {
                                                            staticClass:
                                                              "sub-task",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm.getPermission(
                                                                          "setChildTaskStatus"
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.subtasksCheckbox(
                                                                            item,
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item.checked,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "checked",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "item.checked",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sub-task__bd text-one-line",
                                                                class: {
                                                                  "is-checked":
                                                                    item.checked,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      item.name
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "edit-del-box",
                                                              },
                                                              [
                                                                _vm.getPermission(
                                                                  "updateChildTask"
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "xr-text-btn primary",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.editSubTask(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "编辑"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm.getPermission(
                                                                  "deleteChildTask"
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "xr-text-btn delete",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.deleteSubTask(
                                                                                item
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "删除"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.stop_time
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "bg-color task-bg-color",
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "8px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          item.stop_time,
                                                                          "YYYY-MM-DD"
                                                                        )
                                                                      ) +
                                                                        " 截止"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            item.mainUser ||
                                                            item.main_user_id
                                                              ? _c(
                                                                  "xr-avatar",
                                                                  {
                                                                    staticClass:
                                                                      "user-img",
                                                                    attrs: {
                                                                      name:
                                                                        (item.mainUser &&
                                                                          item
                                                                            .mainUser
                                                                            .realname) ||
                                                                        item.realname,
                                                                      size: 25,
                                                                      src:
                                                                        (item.mainUser &&
                                                                          item
                                                                            .mainUser
                                                                            .thumb_img) ||
                                                                        item.thumb_img,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c("sub-task", {
                                                          attrs: {
                                                            "sub-task-com":
                                                              "edit",
                                                            time: item.stop_time,
                                                            "sub-data": item,
                                                            text: item.name,
                                                            "task-id":
                                                              _vm.subTaskID,
                                                            "checkbox-data":
                                                              item.checked,
                                                            "task-data":
                                                              _vm.taskData,
                                                          },
                                                          on: {
                                                            "on-handle":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.handleSubTasksBlock(
                                                                  $event,
                                                                  item
                                                                )
                                                              },
                                                          },
                                                        }),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.getPermission("addChildTask")
                                          ? [
                                              _vm.addSubtasks
                                                ? _c("div", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "add-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.addSubtasks = false
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "wk wk-l-plus",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "label",
                                                          },
                                                          [_vm._v("子任务")]
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _c("sub-task", {
                                                    attrs: {
                                                      "sub-task-com": "new",
                                                      "task-data": _vm.taskData,
                                                    },
                                                    on: {
                                                      "on-handle":
                                                        _vm.handleSubTasksBlock,
                                                    },
                                                  }),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "section" }, [
                              _c("div", { staticClass: "section__hd" }, [
                                _c("i", { staticClass: "wukong wukong-file" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("附件")]),
                                _vm._v(" "),
                                _vm.fileList.length
                                  ? _c("span", [
                                      _vm._v(
                                        "(" + _vm._s(_vm.fileList.length) + ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "section__bd" },
                                [
                                  _vm._l(
                                    _vm.fileList,
                                    function (file, fileIndex) {
                                      return _c("file-cell", {
                                        key: fileIndex,
                                        attrs: {
                                          data: file,
                                          list: _vm.fileList,
                                          "cell-index": fileIndex,
                                          "module-id": _vm.id,
                                          "show-delete":
                                            _vm.getPermission("deleteTaskFile"),
                                        },
                                        on: { delete: _vm.accessoryDeleteFun },
                                      })
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.getPermission("uploadTaskFile")
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-file",
                                          attrs: {
                                            "http-request": _vm.httpRequest,
                                            action:
                                              "https://jsonplaceholder.typicode.com/posts/",
                                            multiple: "",
                                            "list-type": "picture",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "add-btn" },
                                            [
                                              _c("i", {
                                                staticClass: "wk wk-l-plus",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("附件")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "main__bd--right" },
                        [
                          _c(
                            "el-tabs",
                            {
                              staticClass: "d-container-bd--right",
                              attrs: { value: "comment", type: "border-card" },
                            },
                            [
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "评论",
                                    name: "comment",
                                    lazy: "",
                                  },
                                },
                                [
                                  _c(
                                    "flexbox",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.commentsLoading,
                                          expression: "commentsLoading",
                                        },
                                      ],
                                      staticClass: "comment-cells",
                                      attrs: {
                                        direction: "column",
                                        align: "stretch",
                                      },
                                    },
                                    [
                                      _c("comment-list", {
                                        ref: "comment_list",
                                        attrs: {
                                          id: _vm.taskData.task_id,
                                          list: _vm.replyList,
                                          type: "1",
                                        },
                                        on: {
                                          delete: _vm.deleteComment,
                                          "close-other-reply": function (
                                            $event
                                          ) {
                                            return _vm.$refs.f_reply.toggleFocus(
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("reply-comment", {
                                        ref: "f_reply",
                                        on: {
                                          toggle: _vm.closeOtherReply,
                                          reply: _vm.handleReply,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "活动",
                                    name: "activity",
                                    lazy: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "activity-cells" },
                                    _vm._l(
                                      _vm.activityList,
                                      function (item, index) {
                                        return _c(
                                          "flexbox",
                                          {
                                            key: index,
                                            staticClass: "activity-cell",
                                            attrs: { align: "stretch" },
                                          },
                                          [
                                            _c("xr-avatar", {
                                              staticClass: "user-img",
                                              attrs: {
                                                name: item.realname,
                                                size: 26,
                                                src: item.img || item.thumb_img,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "activity-cell__bd",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "activity-info",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "activity-info--name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.realname)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "activity-info--time",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.create_time
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "activity-content",
                                                  },
                                                  [_vm._v(_vm._s(item.content))]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("c-r-m-full-screen-detail", {
        attrs: {
          visible: _vm.showRelatedDetail,
          "crm-type": _vm.relatedCRMType,
          id: _vm.relatedID,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showRelatedDetail = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }